import { Briefcase, GraduationCap, Check } from "lucide-react";

export const PROFILE_TYPES = [
  { id: "professional", label: "Working Professional", desc: "Salary, bills and long-term saving", icon: Briefcase },
  { id: "student", label: "Student", desc: "Term budgets, loans and Student Hub", icon: GraduationCap },
];

export const profileLabel = (id) => PROFILE_TYPES.find((p) => p.id === id)?.label || "Not set";

export function ProfileTypePicker({ value, onChange, testPrefix = "profile-type" }) {
  return (
    <div role="radiogroup" className="grid grid-cols-2 gap-2.5">
      {PROFILE_TYPES.map((p) => {
        const active = value === p.id;
        return (
          <button
            key={p.id}
            type="button"
            role="radio"
            aria-checked={active}
            data-testid={`${testPrefix}-${p.id}`}
            onClick={() => onChange(p.id)}
            className={`relative flex flex-col items-start justify-start text-left rounded-xl border p-3.5 transition-colors duration-200 ${
              active ? "border-[#00C896] bg-[#00C896]/10" : "border-white/10 bg-[#0D0D0D] hover:border-white/25"
            }`}
          >
            <span className={`h-8 w-8 rounded-lg flex items-center justify-center ${active ? "bg-[#00C896] text-[#04140D]" : "bg-white/5 text-slate-300"}`}>
              <p.icon className="h-4 w-4" />
            </span>
            <span className="block mt-2.5 text-sm font-semibold text-white">{p.label}</span>
            <span className="block mt-0.5 text-[11px] leading-snug text-slate-500">{p.desc}</span>
            {active && <Check className="h-4 w-4 text-[#00C896] absolute top-3 right-3" />}
          </button>
        );
      })}
    </div>
  );
}
